import { render, staticRenderFns } from "./EnglishContact.vue?vue&type=template&id=0eaffc67&scoped=true&"
import script from "./EnglishContact.vue?vue&type=script&lang=js&"
export * from "./EnglishContact.vue?vue&type=script&lang=js&"
import style0 from "./EnglishContact.vue?vue&type=style&index=0&id=0eaffc67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaffc67",
  null
  
)

export default component.exports